// extracted by mini-css-extract-plugin
export default {"loaderContainer":"root_m2-spinner-module__loaderContainer___CeZk2","loader":"root_m2-spinner-module__loader____ybTz"};